import { api_ } from '@shared/plugIn/axios';

/**
 * 비밀번호 변경 — 현재 비밀번호를 모를 때 등록된 휴대폰으로 본인 확인.
 * 백엔드 요청 스펙: smartbugo-api/docs/me-password-phone-verification-spec.md (**구현 대기, 선배선**)
 *
 * 번호는 클라이언트가 보내지 않는다 (계정의 등록 번호로만 발송). 구서버는 404 → 호출부가 안내.
 */

export interface MePasswordPhoneSendResult {
  verificationId: string;
  /** 인터셉터가 Date 로 바꿔 놓는다 */
  expiresAt: Date | string;
  phoneMasked: string;
}

export const sendMePasswordPhoneCode = async (): Promise<MePasswordPhoneSendResult> => {
  const { data } = await api_.post<MePasswordPhoneSendResult>(
    '/auth/me/password/phone-verification/send',
  );
  return data;
};

export interface MePasswordPhoneConfirmResult {
  /** 10분짜리 증명. PATCH /auth/me/password 에 phoneProof 로 동봉 */
  proof: string;
}

export const confirmMePasswordPhoneCode = async (dto: {
  verificationId: string;
  code: string;
}): Promise<MePasswordPhoneConfirmResult> => {
  const { data } = await api_.post<MePasswordPhoneConfirmResult>(
    '/auth/me/password/phone-verification/confirm',
    dto,
  );
  return data;
};

/** 구서버(라우트 없음) 판별 — 404 면 "아직 지원 안 함" 안내 */
export const isUnsupportedServer = (err: unknown): boolean =>
  (err as any)?.response?.status === 404;
